import { useState } from 'react'
import { updateProspect } from '../../../../../api/PRMAPI';
import { notifications } from '@mantine/notifications';
import { useLanguage } from '../../../../../stores/LanguageStore';
import { Select, ThemeIcon } from '@mantine/core';
import { IconThumbDownFilled, IconThumbUp, IconThumbUpFilled } from '@tabler/icons-react';

const PrmCellPositive = ({ row, apiRef }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const onChange = (newValue) => {
    setLoading(true);
    updateProspect({
      id: row.id,
      is_positive: newValue === "null" ? null : newValue === "true" ? true : false
    })
      .then(() => {
        notifications.show({
          message: lang.prm.prospect_updated,
          color: "tertiary.8",
        });

        apiRef.current?.updateRows([
          {
            ...row,
            id: row.id,
            is_positive: newValue === "null" ? null : newValue === "true" ? true : false
          },
        ]);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Select
      onChange={onChange}
      disabled={loading}
      value={row?.is_positive === null ? "null" : row?.is_positive ? "true" : "false"}
      size={"sm"}
      data={[
        { label: lang.prm.positive, value: "true" },
        { label: lang.prm.negative, value: "false" },
        { label: lang.prm.neutral, value: "null" },
      ]}
      comboboxProps={{
        zIndex: 1600,
      }}
      aria-required
      searchable
      leftSection={
        <ThemeIcon color={
          row?.is_positive === null ? "gray" : row?.is_positive ? "green.8" : "red"
        }>
          {row?.is_positive === null ? (
            "-"
          ) : row?.is_positive === false ? (
            <IconThumbDownFilled size={16} />
          ) : (
            <IconThumbUpFilled size={16} />
          )}
        </ThemeIcon>}
    />
  )
}

export default PrmCellPositive